
// --- Vue & Template imports ---
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

// Models
import { MenuItem } from '@/models/Menu.model';

// --- Third Party imports ---
import gsap from 'gsap';
import colors from 'vuetify/lib/util/colors';

@Component
export default class MenuElement extends Vue {
  @Prop(String) readonly mainClass!: string;
  @Prop(String) readonly textColor!: string;
  @Prop(String) readonly hoverColor!: string;
  @Prop(String) readonly hoverTextColor!: string;
  @Prop(String) readonly activeColor!: string;
  @Prop(String) readonly activeTextColor!: string;
  @Prop(String) readonly backgroundColor!: string;
  @Prop(String) readonly childArrowColor!: string;
  @Prop(Object) readonly menuItem!: MenuItem;
  @Prop(Boolean) readonly sidedrawerOpened!: boolean;
  
  storeTextRegex: RegExp = /.[^\s]\/.[^\s]/;

  menuItemClicked(event: Event, clickedMenuItem: MenuItem) {
    if (clickedMenuItem.customEvent) {
      this.$root.$emit(clickedMenuItem.customEvent);
      return; // ??? should this prevent routes etc ???
    }

    if (clickedMenuItem.routeName) {
      this.redirect(clickedMenuItem.routeName);
    }

    if (clickedMenuItem.children && clickedMenuItem.childrenToggle) {
      if (event.currentTarget) {
        const item = event.currentTarget  as HTMLElement;
        const sibling = this.$el.querySelector('.js-component-menu-element-children');

        if (sibling) {
          if (item.classList.contains('state--open')) {
            gsap.to(sibling, {
              duration: 0.1,
              height: 0,
              onStart: () => {
                item.classList.remove('state--open');

                if ((event as PointerEvent).pointerType === 'touch') {
                  item.classList.add('state--touch');
                }
              },
            });            
          } else {
            gsap.set(sibling, { height: 'auto' });
            gsap.from(sibling, {
              duration: 0.1,
              height: 0,
              onStart: () => {
                item.classList.add('state--open');

                if ((event as PointerEvent).pointerType === 'touch') {
                  item.classList.add('state--touch');
                }
              },
              onComplete: () => {
                gsap.set(sibling, { height: 'auto' });
              },
            });
          }
        }
      }
    }
  }

  isMenuChildrenInRoute(menuItem: MenuItem) {
    // check if any of the children actually matches the route, if they don't then apply defaults
    let childMatchesRoute = false;

    if (menuItem.children) {
      for (const [itemIndex, item] of menuItem.children.entries()) {
        if (item.routeName === this.$route.name) {
          childMatchesRoute = true;
        }
      }
    }

    if (childMatchesRoute) {
      return true;
    }

    return false;
  }

  getTextClass() {
    return this.textColor && this.textColor.indexOf('#') === -1 ? ' ' + this.textColor + '--text ' : '';
  }

  getColor(colorString: string) {
    if (colorString.indexOf('#') > -1) {
      return colorString;
    }

    if (this.$vuetify.theme.currentTheme) {
      for (const [colorIndex, color] of Object.entries(this.$vuetify.theme.currentTheme)) {
        if (colorString === colorIndex) {
          return color + '';
        }
      }
    }

    if (colors) {
      for (const [colorIndex, color] of Object.entries(colors)) {
        if (colorString === colorIndex) {
          return color.base + '';
        }
      }
    }

    return colorString;
  }

  redirect(route: string) {
    // check if current route is the route that the menu is going to, ignore if it is
    if (this.$route.name === route) {
      return;
    }

    this.$router.push({ name: route});
  }

  getMenuDisabledState(menuItem: MenuItem) {
    if (typeof menuItem.disabled === 'string') {
      return this.$store.getters[menuItem.disabled];
    }

    return false;
  }

  getMenuDisabledTooltip(menuItem: MenuItem) {
    if (typeof menuItem.disabledTooltip === 'string') {
      return menuItem.disabledTooltip.match(this.storeTextRegex) ? this.$store.getters[menuItem.disabledTooltip] : menuItem.disabledTooltip;
    }

    return false;
  }
}
